class PollBox {

    constructor() {

      if (!this.setVars())
        return

      this.setEvents()

      var poll_id = $("#poll_id").val();

      if (getCookie("poll_" + poll_id) == '1') {
          this.showResults();
      }
    }

    setVars() {

      this.section = document.querySelector('.pollBox')

      if (!this.section)
        return

      this.wrapper      = this.section.querySelector('.pollBox__items')
      this.submit       = this.section.querySelector('.pollBox__submit')
      this.inputs       = this.wrapper.querySelectorAll('.pollBox__itemInput')
      this.percents     = this.wrapper.querySelectorAll('.pollBox__itemPercent')
      this.percentTexts = this.wrapper.querySelectorAll('.pollBox__itemPercentInner')
      this.count        = this.section.querySelector('.pollBox__statsCount')

      return true

    }

    setEvents() {

      this.submit.addEventListener('click', (e) => {

        e.preventDefault()
        this.saveVote()

      })

    }

    showResults() {

      this.inputs.each((item) => {
        item.setAttribute('disabled', 'disabled')
      })

      var poll_id = $("#poll_id").val();
      var that = this;

      $.getJSON("/pollResult?poll_id="+poll_id, function(data) {

          that.wrapper.addClass('pollBox__items--active')
          that.submit.setAttribute('disabled', 'disabled')
          $('.pollBox__submit').hide();

          for (var i = 0; i < data.length; i++) {
              that.percents[i].setAttribute('data-percent', data[i])
              that.percentTexts[i].innerHTML = "" + data[i] + '%'
          }
      });
    }

    saveVote() {

      let value = null
      this.inputs.each((item) => {

        if (item.checked)
          value = item.value

      })

      if (value === null)
        return

      this.inputs.each((item) => {
        item.setAttribute('disabled', 'disabled')
      })

      var poll_id = $("#poll_id").val();
      var that = this;

      $.getJSON("/pollVote?poll_id="+poll_id+"&vote_num="+value, function(data) {

          that.wrapper.addClass('pollBox__items--active')
          that.submit.setAttribute('disabled', 'disabled')
          $('.pollBox__submit').hide();

          for (var i = 0; i < data.length; i++) {
              that.percents[i].setAttribute('data-percent', data[i])
              that.percentTexts[i].innerHTML = "" + data[i] + '%'
          }

          that.count.innerHTML = parseInt(that.count.innerHTML) + 1

          setCookie('poll_' + poll_id, '1', 7);
      });

    }

  }
